module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Shield-thunder-407f23f51ef8cf1003058eeafd596a86.svg";